import { Box, Typography } from "@mui/material";
import deletei from "../../Assets/delete.svg";
import { Link } from "react-router-dom";
import BlockRoundedIcon from "@mui/icons-material/BlockRounded";
import { API_endspoints } from "../../API/API_endspoints";
import { API_POST } from "../../API/config";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";

const drawerWidth = 240;

const UserDetailsSideBar = ({ data, handleData }) => {
  let subType =
    data?.company_details?.subscription?.month === 12 ? "Yearly" : "Monthly";
  let subPlan = data?.company_details?.subscription?.name;
  let price = data?.company_details?.subscription?.price;
  const isTrailPack = data?.company_details?.subscription?.type === 0;
  const isSubscribed = data?.company_details?.subscription?.id;
  // const userDetails = [
  //   { label: "Email", value: data?.email || "", isLink: true },
  //   {
  //     label: "Subscription Type",
  //     value: subPalan,
  //   },
  //   !isTrailPack && {
  //     label: "Payment",
  //     value: `${price} / ${subType}`,
  //   },
  //   {
  //     label: "Subscription End date",
  //     value: data?.company_details?.subscription?.end_time
  //       ? moment
  //           .utc(data?.company_details?.subscription?.end_time)
  //           ?.local()
  //           .format("LL")
  //       : "-",
  //   },
  //   { label: "Country", value: data?.country_name },
  // ];
  const userDetails = [
    { label: "Email", value: data?.email || "", isLink: true },
    {
      label: "Number",
      value: `${
        data?.phno_cc?.startsWith("+")
          ? data.phno_cc
          : `+${data?.phno_cc || ""}`
      } ${data?.phno || ""}`.trim(),
    },
    { label: "Country", value: data?.country_name || "Not Specified" }, // Default fallback

    isSubscribed && {
      label: "Subscription Type",
      value: subPlan || "Not Specified", // Fallback in case subPlan is undefined
    },
    isSubscribed &&
      !isTrailPack &&
      subType &&
      price && {
        label: "Payment",
        value: `€${price} / ${subType}`, // Ensure price and subType exist before formatting
      },
    isSubscribed && {
      label: "Subscription End date",
      value: data?.company_details?.subscription?.end_time
        ? moment
            .utc(data.company_details.subscription.end_time)
            .local()
            .format("LL")
        : "-",
    },
  ].filter(Boolean); // Remove falsy elements (like `false` if isTrailPack is true)

  const handleDelete = async (status) => {
    Swal.fire({
      title: "Are you sure?",
      text:
        status === -1
          ? "You want to block this User"
          : status === 0
          ? "You want to delete this User"
          : "You want to unblock this User",

      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#46adf2",
      cancelButtonColor: "#5b5d5d",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const f = new FormData();
          f.append("user_id", data?.id);
          f.append("status", status);
          let res = await API_POST(API_endspoints.deleteuser, f);
          if (res.s) {
            if (status == 0) {
              toast.success("User Deleted Succesfully");
            } else if (status == -1) {
              toast.success("User Blocked Succesfully");
            } else {
              toast.success("User Unblocked Succesfully");
            }
            handleData();
          }
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  return (
    <Box
      sx={{
        background: `#fff`,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowY: "auto",
        borderRadius: "12px",
        width: drawerWidth,
        "&::-webkit-scrollbar": {
          width: "5px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "10px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#555",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 1.8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: 3,
            background: "#DEE6F280",
            borderRadius: "12px",
            p: 2,
            width: "90%",
            alignItems: "center",
          }}
        >
          <Box sx={{ flexDirection: "column" }} className="flexCenter">
            <img
              // onClick={() => navigate(PathList._Dashboard)}
              src={API_endspoints.baseURL + data?.profile_img}
              height={"90px"}
              width={"90px"}
              style={{ boxSizing: "border-box", borderRadius: "50%" }}
              alt="Logo"
            />
            <Typography
              sx={{
                color: "#164FA1",
                fontWeight: "500",
                fontSize: "16px",
                textWrap: "pretty",
                textAlign: "center",
              }}
            >
              {data?.full_name}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "start",
          flexDirection: "column",
          gap: "0.5rem",
          p: 2,
          // height: "calc(100vh - 115px)",
          // overflowY: "scroll",
        }}
      >
        {userDetails.map((detail, index) => (
          <Box
            key={index}
            sx={{
              borderBottom:
                userDetails.length - 1 !== index && "1px solid #1A130C24",
              width: "100%",
              py: 0.5,
            }}
          >
            <Typography
              sx={{
                color: "grey",
                fontWeight: "700",
                fontSize: "13px",
                py: 0.5,
              }}
            >
              {detail.label}
            </Typography>
            <Typography
              sx={{
                color: "#000",
                fontWeight: "500",
                fontSize: "16px",
                textDecoration:
                  detail.label == "Email" ? "underline" : "pretty",
              }}
            >
              {detail.isLink ? (
                <Link
                  style={{
                    color: "#000",
                    textDecoration: "none",
                    wordBreak: "break-all",
                  }}
                  to={`mailto:${detail.value}`}
                >
                  {detail?.value}
                </Link>
              ) : (
                <p style={{ wordBreak: "break-all" }}>{detail.value}</p>
              )}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
        <Box
          onClick={() => handleDelete(0)}
          sx={{
            background: "#FFC6C6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#FF0000",
            gap: 1,
            p: 1,
            borderRadius: "12px",
            cursor: "pointer",
          }}
        >
          <img
            src={deletei}
            style={{ height: "24px", width: "24px" }}
            alt=""
            srcset=""
          />
          Delete User
        </Box>

        <Box
          onClick={() => handleDelete(data?.status === -1 ? 1 : -1)}
          sx={{
            background: "#DEE6F2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            p: 1,
            borderRadius: "12px",
            color: "#164FA1",
            cursor: "pointer",
          }}
        >
          <BlockRoundedIcon />
          {data?.status == 1 ? "Block User" : "Unblock User"}
        </Box>
      </Box>
    </Box>
  );
};

export default UserDetailsSideBar;
